import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { TransferForm } from "../features/warehouse/TransferForm";

// شاشة كاملة بلا إطار: تعرض TransferForm الذي يوفّر ترويسته الثابتة وزر الإغلاق X.
export default function WarehouseTransferNewPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const branchId = localStorage.getItem("wh.branchId") || "";
  const back = () => navigate("/warehouse");
  if (!branchId) return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-background p-6">
      <div className="rounded-2xl bg-amber-500/10 p-6 text-center text-sm text-amber-700">
        {t("wh.pickBranchFirst")} — <button className="underline" onClick={back}>{t("app.back")}</button>
      </div>
    </div>);
  return <TransferForm branchId={branchId} onClose={back} onDone={back} />;
}
